import { AbsenceEnvironment } from '../app/interfaces/absence-environment.interface';

export const environment: AbsenceEnvironment = {
  production: true,
  env: 'preprod',
  mobileUrl: 'https://preprod-absence.integrix.lu/mobile/',

  api: {
    apiEndPoint: '/api/',
    settingsApi: 'auth/settings',
  },
  app: {
    appName: 'Integrix Absence',
    appVersion: '3.3.4',
    appVersionDate: '02/10/2023',
    defaultRoute: '',
    lang: ['fr', 'pt', 'de', 'nl', 'lu'],
    appId: 'UXmKH0JYl2xkcCtTFEFnmK7oYoLg5yip',
    cache: 0,
  },
  auth: {
    loginUrl: 'api/auth/auth-default',
    logoutUrl: 'api/auth/logout',
    azure: {
      tenant: 'o365.infodata.lu',
      client: '1ab0c7d0-9cba-4569-ab50-cea719fc647c',
      redirectUri: 'https://preprod-absence.integrix.lu/oauth2',
      api: 'auth/auth-azure',
    },
  },
  login: {
    loginRoute: 'login',
    resetRequest: 'auth/reset-request',
    resetPassword: 'auth/reset-password',
    defaultConnection: true,
  },
  portal: {
    api: 'auth/auth-portal',
    portalUri: 'https://preprod-portail.integrix.lu',
    userAppsApi: 'auth/portail-apps',
    loadPortalApps: true,
    imagesUri: 'https://portail.integrix.lu/notifications-email/visu/',
  },
  ui: {
    appLogoPath: 'https://assets.integrix.lu/img/logos/integrix-absence.png',
    companyLogoPath: 'https://assets.integrix.lu/img/logos/infodata.svg',
    lockerBackgroundPath:
      'https://assets.integrix.lu/img/backgrounds/2025.webp',
  },
  changelog: {
    enable: true,
    endpoint:
      'https://changelogs.integrix.lu/api/versions?&WITH=product|=|WEB-ABS',
    route: 'changelogs',
  },
};
